(function () { if (!LN.Core || !LN.Config) throw new Error("LN.Core || LN.Config missing"); })();

(function (Controller, Config, Service, Helper, Model, Handler, Analytics, gapi, LocalStorage, $) {
    'use strict';

    Controller.accederGmail = function () {
        Analytics.clickSSO('Google');
        console.log('Google');

        Service.onGmailLogin(function (isSignedIn) {
            if (isSignedIn && !Model.Window.islockedGmail) {
                Model.Window.islockedGmail = true;
                console.log('LN Login GM onGmailLogin');
                if (Controller.checkStorageSession()) {
                    return; // Otra sesi�n en progreso.
                }
                Helper.resetAll(function () {
                    Controller.accederGmailProcesar();
                });
            }
        });

        if (gapi) {
            console.log('gapi ok');
            if (!gapi.auth2.getAuthInstance().isSignedIn.get()) {
                console.log('LN Login GM No esta autenticado');
                gapi.auth2.getAuthInstance().signIn().then(function () {
                });
            } else {
                if (Controller.checkStorageSession()) {
                    return; // Otra sesi�n en progreso.
                }
                if (!Model.Window.islockedGmail) {
                    Model.Window.islockedGmail = true;
                    console.log('LN Login GM Esta autenticado en gmail');
                    Helper.resetAll(function () {
                        Controller.accederGmailProcesar();
                    });
                }
            }
        }

    };

    Controller.accederGmailProcesar = function () {
        var response = gapi.auth2.getAuthInstance().currentUser.get();
        var profile = response.getBasicProfile();
        Model.Usuario.UsuarioGmailId = profile.getId();
        Model.Usuario.UsuarioDetalleNombre = profile.getGivenName();
        Model.Usuario.UsuarioDetalleApellido = profile.getFamilyName();
        Model.Usuario.GMail = profile.getEmail();
        Model.Usuario.AccessToken = response.getAuthResponse().id_token; 
        Model.Usuario.GGivenName = profile.getGivenName();
        Model.Usuario.GFamilyName = profile.getFamilyName();
        Service.ajaxPost('/Usuario/GestionarRedSocial', Model.Usuario, function (data, status, xhr) {
            if (!Helper.isEmpty(data.code)) {
                var token = xhr.getResponseHeader("X-Token") || Helper.getHeader(data.response, [1]);
                var xvalue = xhr.getResponseHeader("X-Value") || Helper.getHeader(data.response, [2]);

                if ((data.code == "0000") && (token == null || xvalue == null || !token || !xvalue)) {
                    logger && logger.error('GestionarRedSocial (GM) ACCEDER | sin headers', { token, xvalue});
                }
                if (data.code == '0000') Service.storeGM(profile);
                Handler.loginResponseHandler(data, status, xhr);
            }
        }, false, {
            showPreloader: true
        });
    }


    Controller.accederGmailAutomatico = function (id) {
        if (gapi) {
            if (!gapi.auth2.getAuthInstance().isSignedIn.get()) {
                gapi.auth2.getAuthInstance().signIn().then(function (sign) {
                    if (sign.isSignedIn()) {
                        Helper.resetAll(function () {
                            Controller.accederGmailProcesar();
                        });
                    }
                });
            } else {

                if (!Model.Window.islockedGmail) {
                    Model.Window.islockedGmail = true;

                    var response = gapi.auth2.getAuthInstance().currentUser.get();
                    var profile = response.getBasicProfile();

                    if (profile && id == profile.getEmail()) {
                        Helper.resetAll(function () {
                            Controller.accederGmailProcesar();
                        });
                    }
                }
            }
        }




    }

    Controller.asociarGmail = function () {
        console.log('LN Login GM asociarGmail');
        gapi && gapi.auth.authorize({
            client_id: Config.gmId,
            scope: "https://www.googleapis.com/auth/plus.login https://www.googleapis.com/auth/userinfo.email",
            immediate: false
        }, function (gpSignInResponse) {
            var access = gapi.auth.getToken();
            if (gpSignInResponse['g-oauth-window'] !== undefined) {
                gapi.client.load('oauth2', 'v2', function () {
                    gapi.client.oauth2.userinfo.get().execute(function (response) {
                        Controller.asociarGmailProcesar(response);
                    });
                });
            } else {
                // USUARIO YA LOGUEADO PERO SIN ACCION		    	
            }
        });
    };

    Controller.asociarGmailProcesar = function (response) {
        console.log('LN Login GM asociarGmailProcesar');
        gapi && gapi.client.load('plus', 'v1', function () {
            var request = gapi.client.plus.people.get({ 'userId': 'me' });
            request.execute(function (profile) {
                Model.Usuario.UsuarioGmailId = profile.id;
                Model.Usuario.AccessToken = gapi.auth.getToken().access_token;
                Model.Usuario.xToken = Helper.readCookie('token');
                Model.Usuario.xKey = Math.random();
                Service.ajaxPost('/Usuario/AsociarGmail', Model.Usuario, function (data, status, xhr) {
                    if (!Helper.isEmpty(data.code)) {
                        var token = xhr.getResponseHeader("X-Token");
                        var xvalue = xhr.getResponseHeader("X-Value");

                        if ((data.code == "0000") && (token == null || xvalue == null || !token || !xvalue)) {
 						    logger && logger.error('GestionarRedSocial (GM) ASOCIAR | sin headers', { token, xvalue});
                        }
                        Handler.asociarRedSocialResponseHandler(data, status, xhr);
                    }
                }, false, {
                    showPreloader: true,
                    sentHeader: true
                });
            });
        });
    }

})(LN.Controller, LN.Config, LN.Service, LN.Helper, LN.Model, LN.Handler, LN.Analytics, window.gapi, LN.LocalStorage, jQuery);


// WEBPACK FOOTER //
// ./Statics/scripts/login/controllers/gmail.js